import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { FEATURE_NAME, reducer } from './pricing-data.reducer';
import { PricingDataEffects } from './pricing-data.effects';
import { PricingDataService } from './pricing-data.service';
import { PricingDataStore } from './pricing-data.store';
import { PricingDataDispatcher } from './pricing-data.dispatcher';

@NgModule({
  imports: [
    CommonModule,
    EffectsModule.forFeature([PricingDataEffects]),
    StoreModule.forFeature(FEATURE_NAME, reducer),
  ],
  declarations: [],
})
export class PricingDataModule {
  static forRoot(): ModuleWithProviders<PricingDataModule> {
    return {
      ngModule: PricingDataModule,
      providers: [PricingDataService, PricingDataStore, PricingDataDispatcher],
    };
  }
}
